import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HeaderB from "../Header/HeaderB";
import GoBackLink from "../GoBacklink/GoBackLink";
import ProductThumbNailGroup from "../ProductThumbNailGroup/ProductThumbNailGroup";
import AddToCart from "../AddToCart/AddToCart";
import BestGear from "../BestGear/BestGear";
import AlsoLike from "../AlsoLike/AlsoLike";

import Footer from "../Footer/Footer";
import Features from "../Features/Features";
import speakerzx9Img from "../../assets/product-zx9-speaker/desktop/image-product.jpg";
import speakerzx9ImgTab from "../../assets/product-zx9-speaker/tablet/image-product.jpg";
import speakerzx9ImgMobile from "../../assets/product-zx9-speaker/mobile/image-product.jpg";
import speakerzx7Img from "../../assets/shared/desktop/image-zx7-speaker.jpg";
import speakerzx7ImgTab from "../../assets/shared/tablet/image-zx7-speaker.jpg";
import speakerzx7ImgMobile from "../../assets/shared/mobile/image-zx7-speaker.jpg";
import markOneImg from "../../assets/shared/desktop/image-xx99-mark-one-headphones.jpg";
import markOneImgTab from "../../assets/shared/tablet/image-xx99-mark-one-headphones.jpg";
import markOneImgMobile from "../../assets/shared/mobile/image-xx99-mark-one-headphones.jpg";
import xx59 from "../../assets/shared/desktop/image-xx59-headphones.jpg";
import xx59Tab from "../../assets/shared/tablet/image-xx59-headphones.jpg";
import xx59Mobile from "../../assets/shared/mobile/image-xx59-headphones.jpg";
import ProductGallery from "../ProductGallery/ProductGallery";
import imgGallery1 from "../../assets/product-zx9-speaker/desktop/image-gallery-1.jpg";
import imgGallery2 from "../../assets/product-zx9-speaker/desktop/image-gallery-2.jpg";
import imgGallery3 from "../../assets/product-zx9-speaker/desktop/image-gallery-3.jpg";

// import "./HeadphonesMarkOne.module.scss";

const SpeakerZx9 = ({
  addZx9ToCart,
  cart,
  updateMyCart,
  product,
  updateQuantity,
  increment,
  decrement,
  quantity,
}) => {
  const params = useParams();

  const [imgUrl, setImgURL] = useState("");
  const [speakerZX7URl, setspeakerZX7URL] = useState("");
  const [markOneImgURL, setMarkOneImgURL] = useState("");
  const [xx59URL, setxx59URL] = useState("");
  useEffect(() => {
    const handleResize = () => {
      console.log("Resizing...");
      if (window.innerWidth <= 450) {
        setImgURL(speakerzx9ImgMobile);
        setspeakerZX7URL(speakerzx7ImgMobile);
        setMarkOneImgURL(markOneImgMobile);
        setxx59URL(xx59Mobile);
      } else if (window.innerWidth <= 768) {
        console.log("Resizing for SpeakerZx7.jsx tablet view");
        setImgURL(speakerzx9ImgTab);
        setspeakerZX7URL(speakerzx7ImgTab);
        setMarkOneImgURL(markOneImgTab);
        setxx59URL(xx59Tab);
      } else {
        console.log("Resizing for SpeakerZx7.jsx desktop view");

        setImgURL(speakerzx9Img);
        setspeakerZX7URL(speakerzx7Img);
        setMarkOneImgURL(markOneImg);
        setxx59URL(xx59);
      }

      console.log("Resize in Progress");
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <HeaderB
        cart={cart}
        updateCartQuantity={updateQuantity}
        increment={increment}
        decrement={decrement}
        quantity={quantity}
      />
      <main>
        <GoBackLink />
        <AddToCart
          imageURL={imgUrl}
          productName={
            <>
              ZX9 <br /> Speaker
            </>
          }
          description="Upgrade your sound system with the all new ZX9 active speaker. It’s a bookshelf speaker 
          system that offers truly wireless connectivity -- creating new possibilities for more 
          pleasing and practical audio setups."
          price="4500"
          addItem={updateMyCart}
          product={product}
          updateQuantity={updateQuantity}
          quantity={quantity}
          increment={increment}
          decrement={decrement}
        />
        <Features
          p1="Connect via Bluetooth or nearly any wired source. This speaker features optical, digital coaxial, 
          USB Type-B, stereo RCA, and stereo XLR inputs, allowing you to have up to five wired source devices 
          connected for easy switching. Improved bluetooth technology offers near lossless audio quality at 
          up to 328ft (100m)."
          p2="Discover clear, more natural sounding highs than the competition with ZX9’s signature planar diaphragm 
          tweeter. Equally important is its powerful room-shaking bass courtesy of a 6.5” aluminum alloy bass 
          unit. You’ll be able to enjoy equal sound quality whether in a large room or small den. Furthermore, you 
          will experience new sensations from old songs since it can respond to even the subtle waveforms."
        />
        <ProductGallery image={[imgGallery1, imgGallery2, imgGallery3]} />
        <AlsoLike
          image={[speakerZX7URl, markOneImgURL, xx59URL]}
          title={["ZX7 SPEAKER", "XX99 MARK I", "XX59"]}
          nav1={"/speakerZx7"}
          nav2={"/headphones/markOne"}
          nav3={"/headphones/xx59"}
        />
        <ProductThumbNailGroup />
        <BestGear />
        <Footer />
      </main>
    </>
  );
};

export default SpeakerZx9;
